import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../lib/apiClient';

export function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'sent'>('idle');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus('loading');
    setError(null);
    try {
      await forgotPassword(email);
      setStatus('sent');
    } catch (err) {
      setError('We could not send the reset link. Please try again.');
      setStatus('idle');
    }
  };

  return (
    <div className="mx-auto max-w-md space-y-8">
      <div className="space-y-3 text-center">
        <h1 className="text-3xl font-semibold text-foreground">Reset your password</h1>
        <p className="text-sm text-muted-foreground">
          Enter your account email and we will send you a reset link.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="glass-card space-y-4 p-6">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="you@agency.com"
          />
        </div>

        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>}
        {status === 'sent' && (
          <p className="rounded-lg bg-primary/10 px-3 py-2 text-sm text-primary">
            If this email exists, a reset link is on the way.
          </p>
        )}

        <button
          type="submit"
          disabled={status === 'loading'}
          className="focus-ring inline-flex w-full items-center justify-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-primary/30 transition hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === 'loading' ? 'Sending…' : 'Send reset link'}
        </button>
      </form>

      <p className="text-center text-sm text-muted-foreground">
        Remembered your password?{' '}
        <Link to="/login" className="text-primary hover:underline">
          Log in
        </Link>
        .
      </p>
    </div>
  );
}
